<a
  id="{{item.artifact_id}}"
  class="gallery-item"
  queryParamsHandling="merge"
  [ngClass]="{'gallery-item--selected' : searchContainer.selections.selected[item.artifact_id]}"
  [queryParams]="item.$$refData?.queryParams"
  [routerLink]="getRouterLink(item)"
>
  <div class="gallery-item__indicators">
    <div
      class="gallery-item__checkbox-container"
      [ngClass]="{'gallery-item__checkbox-container--selected' : searchContainer.selections.selected[item.artifact_id]}"
    >
      <span
        class="checkbox-tooltip-wrapper"
        [class.cursor-not-allowed]="isCheckboxDisabled(item) && !item.$$used"
        [matTooltip]="isCheckboxDisabled(item) && !item.$$used ? ('TRANS__SEARCH_SELECTIONS__TOO_MANY_SELECTED' | translate) : ''"
        (click)="$event.stopPropagation()"
        (keydown)="null"
      >
        <mat-checkbox
          (click)="select(item, $event)"
          (keydown)="null"
          [checked]="isCheckboxSelected(item)"
          [disabled]="isCheckboxDisabled(item)"
        />
      </span>
    </div>

    @if (item?.is_restricted) {
      <app-restricted-indicator/>
    }
  </div>

  <app-search-result-thumbnail-image
    class="gallery-item__thumb"
    [item]="item"
  />

  @if (item['package_placement.package_id'] && objectPageV2) {
    <app-search-result-package-indicator
      class="gallery-item__package-badge"
      [item]="item"
      [packageDataIsObject]="false"
    />
  }
</a>
